import React from 'react'
import { Form } from 'antd-mobile-v5'
import { useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { List } from 'antd-mobile'
import UploadOssFile from '../../components/FormTools/UploadOssFile'

const Item = List.Item

const RequiredCerts = ({ editable, form }) => {
  const { formatMessage } = useIntl()
  const aow = form.getFieldValue('aow')
  const efr = form.getFieldValue('efr')
  const rescue = form.getFieldValue('rescue')
  const efri = form.getFieldValue('efri')
  const aowFiles = form.getFieldValue('aowFiles')
  const efrfiles = form.getFieldValue('efrfiles')
  const rescueFiles = form.getFieldValue('rescueFiles')
  const { ossSignature } = useSelector((state) => ({
    ossSignature: state.oss.ossSignature,
  }))

  const changeFiles = (fileName, file) => {
    form.setFieldsValue({ [fileName]: file })
  }

  const filename = (dir, type) => `${dir}${type}/`
  return (
    <>
      {aow ? (
        <Item>{`AOW (${aow})`}</Item>
      ) : (
        <Form.Item
          name="aowFiles"
          label={'AOW'}
          form={form}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'form-upload-error' }),
            },
          ]}
        >
          <UploadOssFile
            form={form}
            fileName={filename(ossSignature.dir, 'AOW')}
            ossSignature={ossSignature}
            onSuccess={(file) => changeFiles('aowFiles', file)}
            editable={editable}
            fileList={aowFiles}
            tips={<FormattedMessage id="common-upload-file-reminder" />}
          />
        </Form.Item>
      )}
      {rescue ? (
        <Item>{`RESCUE (${rescue})`}</Item>
      ) : (
        <Form.Item
          name="rescueFiles"
          label={'RESCUE'}
          form={form}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'form-upload-error' }),
            },
          ]}
        >
          <UploadOssFile
            form={form}
            fileName={filename(ossSignature.dir, 'RESCUE')}
            ossSignature={ossSignature}
            onSuccess={(file) => changeFiles('rescueFiles', file)}
            editable={editable}
            fileList={rescueFiles}
            tips={<FormattedMessage id="common-upload-file-reminder" />}
          />
        </Form.Item>
      )}
      {efr || efri ? (
        <Item>
          <FormattedMessage id="app-efr-or-efri" />
          {formatMessage({ id: 'afdi-satisfy' })}
        </Item>
      ) : (
        <Form.Item
          name="efrfiles"
          label={'EFR/EFRI'}
          form={form}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'form-upload-error' }),
            },
          ]}
        >
          <UploadOssFile
            form={form}
            fileName={filename(ossSignature.dir, 'EFR')}
            ossSignature={ossSignature}
            onSuccess={(file) => changeFiles('efrfiles', file)}
            editable={editable}
            fileList={efrfiles}
            tips={<FormattedMessage id="common-upload-file-reminder" />}
          />
        </Form.Item>
      )}
    </>
  )
}

export default RequiredCerts
